var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ApolloError, ApolloLink, Observable } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { GraphQLError } from 'graphql';
import store from 'store';
import { openModal } from 'store/layoutSlice';
export const READ_ONLY_ERROR_CODE = 'READ_ONLY_ACCOUNT';
export const READ_ONLY_NOTICE = 'readOnlyNotice';
// The server owns the account policy. Never duplicate the username condition here.
export const isAccountReadOnly = () => { var _a; return ((_a = store.getState().user.data) === null || _a === void 0 ? void 0 : _a.readOnly) === true; };
export function isReadOnlyError(error) {
    if (error === READ_ONLY_ERROR_CODE)
        return true;
    if (!error || typeof error !== 'object')
        return false;
    const value = error;
    if (value.code === READ_ONLY_ERROR_CODE || value.message === READ_ONLY_ERROR_CODE)
        return true;
    const extensions = value.extensions;
    if ((extensions === null || extensions === void 0 ? void 0 : extensions.code) === READ_ONLY_ERROR_CODE ||
        (extensions === null || extensions === void 0 ? void 0 : extensions.exceptionCode) === READ_ONLY_ERROR_CODE) {
        return true;
    }
    return ((Array.isArray(value.graphQLErrors) && value.graphQLErrors.some(isReadOnlyError)) ||
        (Array.isArray(value.errors) && value.errors.some(isReadOnlyError)) ||
        isReadOnlyError(value.networkError) ||
        isReadOnlyError(value.result));
}
export function showReadOnlyNotice() {
    if (!store.getState().layout.showModals.some((modal) => modal.name === READ_ONLY_NOTICE)) {
        store.dispatch(openModal({ name: READ_ONLY_NOTICE }));
    }
}
export function createReadOnlyError() {
    return new ApolloError({
        graphQLErrors: [
            new GraphQLError(READ_ONLY_ERROR_CODE, undefined, undefined, undefined, undefined, undefined, {
                code: READ_ONLY_ERROR_CODE,
                exceptionCode: READ_ONLY_ERROR_CODE,
            }),
        ],
    });
}
export function assertWriteAccess() {
    if (isAccountReadOnly()) {
        showReadOnlyNotice();
        throw createReadOnlyError();
    }
}
// A rejected operation is still an error, so Apollo rolls back optimistic updates and
// callers cannot mistake a blocked save for success. The backend also checks every write.
export const readOnlyLink = new ApolloLink((operation, forward) => {
    const definition = getMainDefinition(operation.query);
    if (definition.kind === 'OperationDefinition' &&
        definition.operation === 'mutation' &&
        isAccountReadOnly()) {
        return new Observable((observer) => observer.error(createReadOnlyError()));
    }
    return forward(operation);
});
export function handleReadOnlyError(error, silent = false) {
    if (!isReadOnlyError(error))
        return false;
    if (!silent)
        showReadOnlyNotice();
    return true;
}
export function checkReadOnlyResponse(response) {
    return __awaiter(this, void 0, void 0, function* () {
        if (response.status === 403) {
            const body = yield response
                .clone()
                .json()
                .catch(() => null);
            if (handleReadOnlyError(body))
                throw createReadOnlyError();
        }
        return response;
    });
}
